/* 
 *  Created by RRamireddygari 02/14/2018
 */

import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/switchMap'
import { RepoFolder } from '~config/model/repofolder';
import { CompanyFolder } from '~config/model/companyfolder';
import { RepofolderService } from '~config/services/repofolder.service';

@Component({
  selector: 'repofolder-detail',
  templateUrl: './repofolder-detail.component.html',
  styleUrls: ['./repofolder-detail.component.css']
})
export class RepofolderDetailComponent implements OnInit {

  repofolders: RepoFolder[];
  public allMyFolderplaceholder: RepoFolder = new RepoFolder(3, 'ALL MYFOLDERS');
  public allCompFolderplaceholder: RepoFolder = new RepoFolder(2, 'ALL COMPANY FOLDERS');
  public allFolderplaceholder: RepoFolder = new RepoFolder(1, 'ALL STANDARD FOLDERS');
  //public allStandDetailplaceholder: RepoFolder = new RepoFolder(4, 'ALL DETAIL FOLDERS');
  //public allCompDetailplaceholder: RepoFolder = new RepoFolder(5, 'ALL COMPANY DETAIL FOLDERS');
  //public allWidgetReportsPlaceholder: RepoFolder = new RepoFolder(6, 'ALL WIDGET REPORTS');
  folderId: number = -1;

  searchTerm: FormControl;

  companyfolders: CompanyFolder[];

  constructor(private service: RepofolderService) {
    this.searchTerm = new FormControl();
    this.service.getRepoFolders().subscribe((data: RepoFolder[]) => {
      this.repofolders = data;
      this.repofolders.unshift(this.allMyFolderplaceholder);
      this.repofolders.unshift(this.allCompFolderplaceholder);
      this.repofolders.unshift(this.allFolderplaceholder);
      //Save folders list to service to use it in other components
      service.repFolders = this.repofolders;
    });
    this.searchTerm.valueChanges
      .debounceTime(400).distinctUntilChanged()
      .subscribe(data => {
        this.service.search_word(data).subscribe((response: CompanyFolder[])=> {
          this.companyfolders = response;
          service.companyfolders = this.companyfolders;
          console.log(this.searchTerm)
        })
      })

  }

  getTheReportsForTheCompany(event, companyfolder) {
    this.folderId = companyfolder.folderId;
  }

  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// /azp/_work/1/s/src/app/bi-reporting-config/repofolder-detail/repofolder-detail.component.ts